/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-05-26 15:12
 * @LastEditors: wenbin.ma@ginlong.com
 * @LastEditTime: 2026-01-12 16:22
 * @FilePath: \glyun_web_vue3\src\main.js
 * @Description: xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
 */

import './assets/css/index.scss'
import './assets/css/element/element-icon.css'
import { ElMessage } from 'element-plus'
import directives from './directive/index.js'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useUserStore } from '@/stores/user'
import useBusinessDictStore from '@/stores/businessDict.js'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import _CONST from '@/const/index'


import App from './App.vue'
import router from './router'
import dayjs from 'dayjs' //dayjs.js 时间格式化
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
// vue-i18n
import i18n from '@/lang'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { updateTheme, updateIco } from '@/utils/changeSystem/index.js'
// 初始化element-plus组件库默认值
import "@/utils/plugin/initElementPlus.js"
if(localStorage.getItem("iconUrl")){
  updateIco(localStorage.getItem("iconUrl"))
}
import WujieVue from 'wujie-vue3'
const { setupApp, preloadApp, bus } = WujieVue
const app = createApp(App)
console.log("行号: mian-3", JSON.parse(localStorage.getItem('userInfo')))

app.config.globalProperties.$accessType = import.meta.env.VITE_ACCESS_TYPE
app.config.globalProperties.$accessType_zh = _CONST.$accessType_zh
app.config.globalProperties.$accessType_en = _CONST.$accessType_en

app.config.globalProperties.$dayjs = dayjs

// 初始化主题色
const themeColor = localStorage.getItem('themeColor')
if (themeColor) {
  updateTheme(themeColor)
}

// 初始化全局访问器
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 全局注册验证码组件（国际版hCaptcha / 国内版AJ-Captcha）
// import GlCaptcha from '@/components/GlCaptcha/index.vue'
// app.component('GlCaptcha', GlCaptcha)

preloadApp({
  name: import.meta.env.VITE_CHILD_APP_NAME,
  url: `${import.meta.env.VITE_CHILD_APP_URL}`,
  // props: props,
  exec: true, // 预加载
  // alive: true,
  // 核心：拦截 fetch 请求，放行指定第三方域名
  /*fetch: async (input, init) => {
    console.log("🚀 ~ input, init:", input, typeof input === 'string', init)
    // 1. 定义需要放行的第三方域名列表（按需添加）
    const allowList = [
      'maps.googleapis.com', // 谷歌地图
    ];

    // 2. 判断当前请求是否属于第三方允许列表
    const requestUrl = typeof input === 'string' ? input : input.url;
    const isAllowed = allowList.some(domain => requestUrl.includes(domain));

    if (isAllowed) {
      // 方案A：直接调用原生 fetch，跳过无界的拦截处理
      // return window.fetch.call(window, input, init);

      // 方案B（针对 script 转 fetch 的场景）：拒绝 fetch，强制走原生 script 加载
      return new Response('', { status: 403, statusText: 'Force script load' });
    }

    // 非第三方请求，走无界默认的 fetch 逻辑
    return fetch(input, init);
  },*/
})
app.use(router).use(pinia).use(i18n).use(WujieVue).use(directives)
// 提前初始化业务字典缓存和语言切换监听。
useBusinessDictStore(pinia)
app.mount('#app')
// 异常捕获
let timer = null
window.addEventListener('error', (event) => {
  console.log("🚀 ~ event:", event, "html")
  // 处理资源加载错误
  const target = event.target;
  console.log("🚀 ~ target:", target)
  console.log("🚀 ~ verifyErrorFileSrc(target):", verifyErrorFileSrc(target))
  if (verifyErrorFileSrc(target) && (target.tagName === 'SCRIPT' || target.tagName === 'LINK')) {
    const errorMsg = `JS文件加载失败: ${target.src},${target.href}`;
    console.log("🚀 ~ errorMsg:", errorMsg)
    clearTimeout(timer)
    timer = setTimeout(() => {
      ElMessage.primary(i18n.global.t("v2_a_new_version_is_available_the"))
      location.reload(true)
    }, 300)
  }
}, true);
function verifyErrorFileSrc(target){
  let src
  if(target.tagName === 'SCRIPT'){
    src = target.src
  }else if(target.tagName === 'LINK'){
    src = target.href
  }
  // 创建一个正则表达式，以匹配以当前 origin 开头的 URL
  const origin = window.location.origin.replaceAll(".", "\.");
  const regex = new RegExp(`^${origin}/(js|css)/index-[0-9a-zA-Z]{1,}\.(js|css)$`, 'i'); // 'i' 标志表示不区分大小写

  // 测试一个 URL 是否匹配
  return regex.test(src); // 这将返回 true 如果 testUrl 以 origin 开头
}
